/** @jsxImportSource @emotion/react */
import { Box, useTheme } from '@mui/material'
import { usePropertyMap } from '@app/contexts/ModuleMapContexts/PropertyMapContext/PropertyMapContext'
import { Alert } from '@app/components/Atoms/Alert/Alert'
import { Badge } from '@app/components/Atoms/Badge'
import { PropertyMapView } from '@app/components/Molecules/MapView/PropertyMapView'
import { SideDrawer } from '@app/components/Molecules/SideDrawer'
import { SideDrawerContent } from '@app/components/Property/components/SideDrawerContent'
import { usePropertyMapEffects } from '@app/components/Property/hooks/usePropertyMapEffects'
import { MapboxOptions } from 'mapbox-gl'
import { useState } from 'react'
import {
  contentWrapper,
  innerContentWrapper,
  propertyPageContainer,
  sideDrawerContainer,
} from './PropertyPage.styles'

export type ViewOrientation = Pick<
  MapboxOptions,
  'center' | 'zoom' | 'pitch' | 'maxPitch' | 'zoom' | 'bearing'
>

export type sideDrawerTab = 'Risk' | 'Stories' | 'Welcome & FAQ'

export const PropertyPage = () => {
  const theme = useTheme()
  const [isDrawerOpen, setSideDrawerIsOpen] = useState(true)
  const mapContext = usePropertyMap()
  const { setMapPadding, flyTo, map, getMapPadding } = mapContext
  usePropertyMapEffects()

  // TODO: handle full screen

  return (
    <Box css={propertyPageContainer} id="propertyPageContainer">
      <Alert open={true} message="Property Explorer is in Beta">
        <Badge>Beta</Badge>
      </Alert>
      <Box css={contentWrapper}>
        <Box css={innerContentWrapper}>
          <Box css={sideDrawerContainer}>
            <SideDrawer
              isOpen={isDrawerOpen}
              mapContext={mapContext}
              handleToggle={() => {
                setSideDrawerIsOpen(!isDrawerOpen)
              }}
              color={theme.palette.primary.main}
              side="left"
              initialWidth={600}
              handleWidthChange={(width: number) => {
                const { left: previousWidth } = getMapPadding(true)
                setMapPadding({ top: 0, left: width, bottom: 0, right: 0 })

                if (map && width != previousWidth) {
                  flyTo({
                    latitude: map.getCenter().lat,
                    longitude: map.getCenter().lng,
                    zoom: map.getZoom(),
                    usePadding: true,
                    duration: 800,
                  })
                }
              }}
            >
              <SideDrawerContent />
            </SideDrawer>
          </Box>
          <PropertyMapView />
        </Box>
      </Box>
    </Box>
  )
}
